import { render } from "./HeroBlog.vue?vue&type=template&id=d8d7363e&scoped=true"
import script from "./HeroBlog.vue?vue&type=script&lang=js"
export * from "./HeroBlog.vue?vue&type=script&lang=js"

import "./HeroBlog.vue?vue&type=style&index=0&id=d8d7363e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d7363e"]])

export default __exports__